import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background/80 backdrop-blur-md border-b border-neutral-200/50 py-4' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-164">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-165">
        <div className="flex items-center gap-2 group cursor-pointer" data-id="element-166">
          <div className="w-6 h-6 bg-foreground rounded-sm flex items-center justify-center group-hover:bg-accent transition-colors" data-id="element-167">
            <div className="w-2 h-2 bg-background rounded-full" data-id="element-168" />
          </div>
          <span className="font-serif text-xl font-medium tracking-tight" data-id="element-169">
            Anthropify
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-neutral-600" data-id="element-170">
          <a href="#timeline" className="hover:text-foreground transition-colors" data-id="element-171">
            The 5th Shift
          </a>
          <a href="#approach" className="hover:text-foreground transition-colors" data-id="element-172">
            Our Approach
          </a>
          <a href="#deliverables" className="hover:text-foreground transition-colors" data-id="element-173">
            Deliverables
          </a>
        </div>

        <div className="flex items-center gap-4" data-id="element-174">
          <a href="#contact" className="hidden md:inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium text-white bg-foreground hover:bg-accent transition-colors rounded-full" data-id="element-175">
            Book Discovery
          </a>
        </div>
      </div>
    </motion.nav>;
}